import { themeType } from '../../ui-kit/helpers';
import { isMobileOnly } from 'react-device-detect';

// https://favro.com/organization/c6c415f4b7ca01f8bdc6f755/62048a273ebae44305946712?card=Fir-13362
export const dashboardBgColor = themeType === 'light' ? 'var(--bs-gray-100)' : 'var(--bs-dark)';

// https://favro.com/organization/c6c415f4b7ca01f8bdc6f755/62048a273ebae44305946712?card=Fir-13362
// make border disappear
export const widgetBorderColor = themeType === 'light' ? 'var(--bs-gray-100)' : 'var(--bs-dark)';

export const widgetBgColor = themeType === 'light' ? 'var(--bs-gray-100)' : 'var(--bs-dark)';

export const widgetInnerPadding = isMobileOnly ? 'p-0' : 'p-2';
